import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service'

@Injectable()
export class CitipostOnlyGuard implements CanActivate {
  constructor(private userservice: UserService ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      return this.userservice.isCitipostOnly();  
    }
}
